import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const blogSlice = createApi({
    reducerPath: "blogSlice",
    baseQuery: fetchBaseQuery({ baseUrl: `${process.env.REACT_APP_BLOG_LIST_BASE_URL}` }),
    endpoints: (builder) => ({
        getBlogList: builder.query({
            query: () => {
                return {
                    // url: '/api/v2/document/Blog Post?fields=["name=ar-vr-transforming-the-e-commerce","title","blog_category","modified","meta_image","blog_intro", "content_md"]',
                    url: '/api/v2/document/Blog Post?fields=["name","title","blog_category","modified","meta_image","blog_intro", "content_md"]&filters=[["published", "=", "1"]]',
                    method: "GET",
                    headers: {
                        "Authorization": `token ${process.env.REACT_APP_BLOG_LIST_KEY}:${process.env.REACT_APP_BLOG_LIST_SECRET}`,
                    },
                };
            }
        }),
        getSingleBlog: builder.query({
            query: (name) => {
                return {
                    url: `/api/v2/document/Blog Post/${name}`,
                    method: "GET",
                    headers: {
                        "Authorization": `token ${process.env.REACT_APP_BLOG_LIST_KEY}:${process.env.REACT_APP_BLOG_LIST_SECRET}`,
                    },
                };
            }
        }),
    }),
}); 

export const { useGetBlogListQuery, useGetSingleBlogQuery } = blogSlice;